import {Injectable, inject} from '@angular/core';
import {ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable, of} from 'rxjs';
import {first, mergeMap} from 'rxjs/operators';
import {GuiPermissionsService} from '../_services/gui/gui-permissions.service';

@Injectable({
  providedIn: 'root'
})
export class BusinessUserGuard  {
  private readonly guiPermissionsService = inject(GuiPermissionsService);


  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    return this.guiPermissionsService.canViewBusiness$.pipe(
      first(),
      mergeMap(b => b ? of(b) : this.guiPermissionsService.companyAdminRedirectUrlTree$)
    );
  }

}
